// extracted by mini-css-extract-plugin
var _1 = "EmailImportantButton-moduleEmailImportantButton__MQqkQ";
var _2 = "EmailImportantButton-moduledisabled__y3qpM";
var _3 = "EmailImportantButton-moduleicon__BakDo IconNG-moduleiconContainer__SxWZ0";
var _4 = "EmailImportantButton-moduleiconBackground__sk3tF";
var _5 = "EmailImportantButton-moduleiconContainer__DJ6vV";
export { _1 as "EmailImportantButton", _2 as "disabled", _3 as "icon", _4 as "iconBackground", _5 as "iconContainer" }
